import { SubscriptionTier } from '../services/api';

const parseLimit = (value: string | undefined, fallback: number): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
};

const SUBSCRIPTION_LIMITS: Record<SubscriptionTier, { contractsPerMonth: number; questionsPerContractMonth: number }> = {
  [SubscriptionTier.FREE]: {
    contractsPerMonth: parseLimit(process.env.REACT_APP_FREE_CONTRACTS_PER_MONTH, 5),
    questionsPerContractMonth: parseLimit(process.env.REACT_APP_FREE_QUESTIONS_PER_CONTRACT_MONTH, 1)
  },
  [SubscriptionTier.PREMIUM]: {
    contractsPerMonth: parseLimit(process.env.REACT_APP_PREMIUM_CONTRACTS_PER_MONTH, 10),
    questionsPerContractMonth: parseLimit(process.env.REACT_APP_PREMIUM_QUESTIONS_PER_CONTRACT_MONTH, 20)
  },
  [SubscriptionTier.PLATINUM]: {
    contractsPerMonth: parseLimit(process.env.REACT_APP_PLATINUM_CONTRACTS_PER_MONTH, 50),
    questionsPerContractMonth: parseLimit(process.env.REACT_APP_PLATINUM_QUESTIONS_PER_CONTRACT_MONTH, 50)
  }
};

export interface TierFeatures {
  tier: SubscriptionTier;
  name: string;
  tagline: string;
  marketingDescription: string;
  contractsPerMonth: number;
  questionsPerContractMonth: number;
  hasRiskDetails: boolean;
  hasMessageBuilder: boolean;
  hasNotifications: boolean;
  priceMonthly?: number;
  priceYearly?: number;
  features: string[];
}

export const TIER_FEATURES: Record<SubscriptionTier, TierFeatures> = {
  [SubscriptionTier.FREE]: {
    tier: SubscriptionTier.FREE,
    name: 'Gratuito',
    tagline: 'Para entender antes de assinar',
    marketingDescription: '',
    contractsPerMonth: SUBSCRIPTION_LIMITS[SubscriptionTier.FREE].contractsPerMonth,
    questionsPerContractMonth: SUBSCRIPTION_LIMITS[SubscriptionTier.FREE].questionsPerContractMonth,
    hasRiskDetails: false,
    hasMessageBuilder: false,
    hasNotifications: false,
    features: [
      `Até ${SUBSCRIPTION_LIMITS[SubscriptionTier.FREE].contractsPerMonth} contratos por mês`,
      'Estatísticas de risco',
      'Análise básica de contrato'
    ]
  },
  [SubscriptionTier.PREMIUM]: {
    tier: SubscriptionTier.PREMIUM,
    name: 'Premium',
    tagline: 'Acompanhamento durante o contrato',
    marketingDescription: '',
    contractsPerMonth: SUBSCRIPTION_LIMITS[SubscriptionTier.PREMIUM].contractsPerMonth,
    questionsPerContractMonth: SUBSCRIPTION_LIMITS[SubscriptionTier.PREMIUM].questionsPerContractMonth,
    hasRiskDetails: true,
    hasMessageBuilder: true,
    hasNotifications: true,
    priceMonthly: 5.00,
    priceYearly: 50.00,
    features: [
      'Análise completa de riscos',
      'Perguntas à IA',
      'Recomendações detalhadas',
      'Mensagens para negociação',
      'Lembretes e notificações'
    ]
  },
  [SubscriptionTier.PLATINUM]: {
    tier: SubscriptionTier.PLATINUM,
    name: 'Platinum',
    tagline: 'Tranquilidade total',
    marketingDescription: '',
    contractsPerMonth: SUBSCRIPTION_LIMITS[SubscriptionTier.PLATINUM].contractsPerMonth,
    questionsPerContractMonth: SUBSCRIPTION_LIMITS[SubscriptionTier.PLATINUM].questionsPerContractMonth,
    hasRiskDetails: true,
    hasMessageBuilder: true,
    hasNotifications: true,
    priceMonthly: 20.00,
    priceYearly: 200.00,
    features: [
      'Tudo do Premium',
      'Mensagens para negociação',
      'Lembretes e notificações',
      'Suporte prioritário'
    ]
  }
};

export const UPGRADE_MESSAGE_KEYS = {
  CONTRACT_LIMIT: 'documents:upgradeMessages.contractLimit',
  QUESTION_LIMIT: 'documents:upgradeMessages.questionLimit',
  LOCKED_FEATURE: 'documents:upgradeMessages.lockedFeature',
  MESSAGE_BUILDER: 'documents:upgradeMessages.messageBuilder'
};
